import React from "react";
import {Control} from "react-hook-form";
import {Typography, Grid} from "@mui/material";
import {FormInputText} from "../../shop/wholesale/form/FormInputText";
import {FormInputNumber} from "../../shop/wholesale/form/FormInputNumber";
import {FormInputCheckbox} from "../../shop/wholesale/form/FormInputCheckbox";
import {ShippingCarrierFormData} from "./ShippingCarrierForm";

interface ShipmondoEditorProps {
   control: Control<ShippingCarrierFormData>;
}

export const ShipmondoEditor: React.FC<ShipmondoEditorProps> = ({control}) => {
   return (
      <div>
         <Typography variant="h2" gutterBottom>
            Shipmondo Integration
         </Typography>
         
         <Grid container spacing={3}>
            <Grid item xs={12} md={2}>
               <FormInputText name="shipmondo.carrier" label="Default carrier (glsdk, pdk_rho,...)" />
            </Grid>
            <Grid item xs={12} md={2}>
               <FormInputText name="shipmondo.carrierSecondary" label="Secondary carrier (glsdk, pdk_rho,...)" />
            </Grid>
            <Grid item xs={12} md={4}>
               <FormInputText name="shipmondo.carrierCode" label="Carrier_code (gls, pdk,...)" />
            </Grid>
            <Grid item xs={12} md={4}>
               <FormInputText name="shipmondo.serviceCodes" label="Service codes" />
            </Grid>
         </Grid>

         <Grid container spacing={3}>
            <Grid item xs={12} md={3}>
               <FormInputText name="shipmondo.customerNumber" label="Shipping Agreement Nr" />
            </Grid>
            <Grid item xs={12} md={3}>
               <FormInputText name="shipmondo.qrX" label="QR - X pos" />
            </Grid>
            <Grid item xs={12} md={3}>
               <FormInputText name="shipmondo.qrY" label="QR - Y pos" />
            </Grid>
            <Grid item xs={12} md={3}>
               <FormInputNumber name="shipmondo.qrSize" label="QR - Size" />
            </Grid>
         </Grid>

         <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
               <FormInputNumber name="shipmondo.height" label="Parcel - height (cm)" />
            </Grid>
            <Grid item xs={12} md={4}>
               <FormInputNumber name="shipmondo.width" label="Parcel - width (cm)" />
            </Grid>
            <Grid item xs={12} md={4}>
               <FormInputNumber name="shipmondo.length" label="Parcel - length (cm)" />
            </Grid>
         </Grid>

         <Grid container spacing={3}>
            <Grid item xs={12}>
               <FormInputText name="shipmondo.description" label="Parcel - content description" />
            </Grid>
         </Grid>

         <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
               <FormInputCheckbox name="shipmondo.ownAgreement" label="Use own agreement" />
            </Grid>
            <Grid item xs={12} md={6}>
               <FormInputCheckbox name="shipmondo.testMode" label="Test mode" />
            </Grid>
         </Grid>

         <Grid container spacing={3}>
            <Grid item xs={12}>
               <FormInputText 
                  name="shipmondo.customs" 
                  label="Customs Declarations"
                  multiline
                  rows={5}
               />
            </Grid>
         </Grid>
      </div>
   );
};